import {DatePeriod, DateTimePeriod, ScheduleCalendarType} from '../../types';
import {getPeriod, getPeriodWithPadding} from '../../functions';
import {toDatePeriod} from './toDatePeriod';
import {getDateTimeString} from '../../../../utils';

export const getMinViewModelPeriod = (
  date: Date | string,
  calendarType: ScheduleCalendarType,
): DatePeriod => {
  const periodWithPadding = getPeriodWithPadding(date, calendarType);
  const {from, to} = getPeriod(date, 'month');
  const enclosingMonth: DateTimePeriod = {
    fromDateTime: getDateTimeString(from),
    toDateTime: getDateTimeString(to),
  };

  return toDatePeriod({
    fromDateTime:
      periodWithPadding.fromDateTime < enclosingMonth.fromDateTime
        ? periodWithPadding.fromDateTime
        : enclosingMonth.fromDateTime,
    toDateTime:
      periodWithPadding.toDateTime > enclosingMonth.toDateTime
        ? periodWithPadding.toDateTime
        : enclosingMonth.toDateTime,
  });
};
